var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9974 21.8327C16.9805 21.8327 21.8307 16.9824 21.8307 10.9993C21.8307 5.01626 16.9805 0.166016 10.9974 0.166016C5.01431 0.166016 0.164062 5.01626 0.164062 10.9993C0.164062 16.9824 5.01431 21.8327 10.9974 21.8327Z",
    fill: "url(#paint0_linear_66_1992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.084C12.7949 12.084 14.25 10.6289 14.25 8.83398C14.25 7.03906 12.7949 5.58398 11 5.58398C9.20507 5.58398 7.75 7.03906 7.75 8.83398C7.75 10.6289 9.20507 12.084 11 12.084Z",
    fill: "#181A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58594 17.418V15.6026C5.58594 15.0232 5.81421 14.4675 6.22054 14.0578C6.62687 13.6481 7.17797 13.418 7.7526 13.418H14.2526C14.8272 13.418 15.3783 13.6481 15.7847 14.0578C16.191 14.4675 16.4193 15.0232 16.4193 15.6026V17.418",
    fill: "#181A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_1992",
    x1: 14.5664,
    y1: 13.6575,
    x2: -5.37497,
    y2: 14.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDDFC",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_1992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyProfileIcon);
export default __webpack_public_path__ + "static/media/cy-profile-icon.b81cb45f6e512743c5ae3dcd70331020.svg";
export { ForwardRef as ReactComponent };